import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import GeneralInformations from "./generalInformations";
import AccessRights from './accessRights';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from "react-router-dom";
import CancelActionAlert from "../../../common/alerts/cancelActionAlert/cancelActionAlert";
import {alertLevel, cancellingAlertFlags} from "../../../constants/alert/alertFlags";
import {endpoints} from "../../../constants/endpoints";
import CircularProgress from "@material-ui/core/CircularProgress";
import {emailValidation, usernameValidation} from "../../../constants/validations/validationTypes";
import {getRestrictedDomains} from "../createUserHelper";
import _ from "lodash";
import {logout} from "../../../redux/actions";
import {sectionTitles} from "../../../constants/names/titles";
import {checkTokenAvailability} from "../../../common/utils/utils";
import {userTypes} from "../../../constants/types/userTypes";
import {useSnackbar} from "notistack";
import {snackbarMessages} from "../../../constants/alert/alertMessages";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme) => ({
    layout: {
        width: '95%',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.up(1000 + theme.spacing(2) * 2)]: {
            maxWidth: '95%',
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        padding:12
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        width: 'auto',
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

export default function CreateHospiceUser(props) {
    let history = useHistory();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();
    const [wasSuccessful, setWasSuccessful] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [user_id, setUser_id] = useState();
    const [first_role, setFirst_Role] = useState(0);
    const isLogged = useSelector(state => state.isLogged);
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [firstStep, setFirstStep] = useState(true);
    const [secondStep, setSecondStep] = useState(true);
    const [entered, setEntered] = useState(false);
    const [hospicesList, setHospiceList] = useState([]);
    const [regionList, setRegionList] = useState({});
    const [rolesList, setRolesList] = useState([{value: '', label: ''}]);
    const [roleCategories, setRolesCategories] = useState([]);
    const [permissionList, setPermissionList] = useState([]);
    const [restrictedDomains, setRestrictedDomain] = useState([]);
    const [initialEmail, setInitialEmail] = useState("");
    const [possibleEmail, setPossibleEmail] = useState(props.edit ? ["You cannot edit usernames!"] : ["Add First and Last name for suggestions"]);
    const [validEmail, setValidEmail] = useState(emailValidation.empty);
    const [validUsername, setValidUsername] = useState(usernameValidation.empty);
    const [teamData, setTeamData] = useState([]);
    const [teamList, setTeamList] = useState([]);
    const [hospiceData, setHospiceData] = useState([]);
    const [regionData, setRegionData] = useState([]);
    const [userType, setUserType] = useState(userTypes.hospice)
    const [user, setUser] = useState({
        status: true,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        organization_id: '',
        region: null,
        team: null,
        title: '',
        role_id: '',
        permissions: [],
        username: '',
        deleted: false,
    });

    const getRolePermissions = () => {
        (async () => {
            const availableToken = await checkTokenAvailability();
            if (!availableToken) {
                dispatch(logout());
                history.push('/login');
            }
        })();
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(`${endpoints.permissions}${user.role_id}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                setPermissionList(response.data);
            })
            .catch(err => console.log('error', err))
    };

    const checkAvailability = async (target, value) => {
        (async () => {
            const availableToken = await checkTokenAvailability();
            if (!availableToken) {
                dispatch(logout());
                history.push('/login');
            }
        })();
        const token = JSON.parse(localStorage.getItem('key'));
        let endpoint;
        if (target === "email") {
            endpoint = endpoints.checkEmailAvailability;
        } else {
            endpoint = endpoints.checkUsernameAvailability;
        }
        const promise = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
            body: JSON.stringify({value: value})
        });
        const response = await promise.json();
        if (target === "email" && value !== initialEmail) {
            if (response.status === "success") {
                validEmail === true && setValidEmail(emailValidation.success)
            } else {
                setValidEmail(emailValidation.emailAlreadyExists)
            }
        } else {
            response.status === "success" ? setValidUsername(usernameValidation.success) : setValidUsername(usernameValidation.usernameAlreadyExists);
        }

    };
    useEffect(() => {
        getRolePermissions();
    }, [user.role_id]);

    function getCategories() {
        let categories = [];

        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        permissionList.map(permission => categories.push(permission.category));
        let uniqueNames = categories.filter(onlyUnique);
        setRolesCategories(uniqueNames);
    }

    const [missingValues, setMissingValues] = React.useState({
        organization_id: null, first_name: null, last_name: null, email: null,
        phone: null, role_id: null, region: null,
    });

    function getHospiceOrganizations() {
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(endpoints.getAllHospiceIds, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                let object = [];
                for (let i = 0; i < response.data.length; i++) {
                    object.push({value: response.data[i].hospice_organization_id, label: response.data[i].hospice_name})
                }
                setHospiceData(response.data);
                setHospiceList(object);

            })
            .catch(err => console.log('error', err))
    }

    function getRegions() {
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(endpoints.getHospiceRegions + user.organization_id, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                let object = [];
                for (let i = 0; i < response.data.length; i++) {
                    object.push({value: response.data[i].name, label: response.data[i].name})
                }
                setRegionData(response.data);
                setRegionList(object);

            })
            .catch(err => {
                console.log('error', err);
                setRegionData([]);
                setRegionList([]);
            })
    }

    const getTeams = () => {
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(endpoints.getHospiceTeams + user.organization_id, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                let object = [];
                for (let i = 0; i < response.data.length; i++) {
                    object.push({value: response.data[i].team_name, label: response.data[i].team_name})
                }
                setTeamList(object);
                setTeamData(response.data)
            })
            .catch(err => {
                console.log('error', err);
                setTeamList([]);
                setTeamData([])
            })
    };

    function getRoles(type) {
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(endpoints.hospice_roles + type, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                let object = [];
                for (let i = 0; i < response.data.length; i++) {
                    object.push({value: response.data[i].role_id, label: response.data[i].name})
                }
                setRolesList(object);
            })
            .catch(err => console.log('error', err))
    }

    const updatePermissionIDs = () => {
        let list = [];
        permissionList.map(permission => {
            list.push(permission.permission_id);
        });
        setUser({...user, permissions: list})
    };

    useEffect(() => {
        getHospiceOrganizations();
        getRestrictedDomains(setRestrictedDomain);
        if(props.location.state && props.location.state.userType){
            setUserType(props.location.state.userType)
        }
        if(props.location.state && props.location.state.id){
            setUser_id(props.location.state.id);
        } else {
            let urlParameters = window.location.href.split('/');
            setUser_id(Number(urlParameters[urlParameters.length - 1]))
        }
    }, []);

    useEffect(() => {
        if (user.organization_id) {
            getRegions();
            getTeams();
        }
    }, [user.organization_id, props.edit]);

    useEffect(() => {
        getCategories();
        if (user.role_id && parseInt(user.role_id) !== first_role) {
            updatePermissionIDs();
        }
    }, [permissionList]);


    function getData() {
        getHospiceOrganizations();
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(`${endpoints.hospice_user}${user_id}`, {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                return response.json()
            })
            .then(response => {
                setFirst_Role(Number(response.data[0].role_id));
                let arr = [];
                if (response.data[0].permissions[0] && response.data[0].permissions[0].permission_id){
                    response.data[0].permissions.map(permission => arr.push(Number(permission.permission_id)));
                } else {
                    response.data[0].permissions.map(permission => arr.push(Number(permission)));
                }
                setUser(prevState => ({
                    ...prevState,
                    first_name: response.data[0].first_name,
                    last_name: response.data[0].last_name ? response.data[0].last_name : "",
                    organization_id: parseInt(response.data[0].hospice_organization_id),
                    email: response.data[0].email ? response.data[0].email : "",
                    team: response.data[0].team_id ? parseInt(response.data[0].team_id) : null,
                    title: response.data[0].title,
                    role_id: response.data[0].role_id,
                    phone: response.data[0].phone ? response.data[0].phone : "",
                    status: response.data[0].status,
                    region: response.data[0].region_id ? parseInt(response.data[0].region_id) : null,
                    permissions: arr,
                    username: response.data[0].username,
                    deleted: response.data[0].deleted,
                }));
                setInitialEmail(response.data[0].email ? response.data[0].email : "");
                setValidUsername(usernameValidation.success);
                setValidEmail(emailValidation.success);
            }).catch(err => console.log('error', err))
    }

    useEffect(() => {
        if (props.edit && user_id !== undefined) {
            getData();
        }
    }, [user_id]);

    useEffect(() => {
        getRoles(userType);
    }, [user.role_id]);

    useEffect(() => {
        if (user.role_id !== '') {
            if (props.edit && validEmail === emailValidation.success) {
                setFirstStep(true);
            } else if (validUsername === usernameValidation.success && validEmail === emailValidation.success) {
                setFirstStep(true);
            } else {
                setFirstStep(false);
            }
        } else {
            setFirstStep(false);
        }
    }, [user, validUsername, validEmail]);

    function handleInput(e, type) {
        setUser({...user, [e.target.name]: e.target.value})
    }

    function handleRequiredInput(e, type) {
        setUser({...user, [e.target.name]: e.target.value})
    }

    const handleStatus = () => {
        const values = {...user};
        values.status = !user.status;
        setUser(values);
    };

    const deleteUser = () => {

        (async () => {
            const availableToken = await checkTokenAvailability();
            if (!availableToken) {
                dispatch(logout());
                history.push('/login');
            }
        })();
        const token = JSON.parse(localStorage.getItem('key'));
        fetch(endpoints.deleteUser + user_id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token.accessToken
            },
        })
            .then(response => {
                if (response.status === 204) {
                    setUser({...user, deleted: true});
                    if(userType === userTypes.hospice) {
                        setTimeout(() => history.push("/admin/hospiceusers/all"), 1000);
                    }
                    if(userType === userTypes.portal) {
                        setTimeout(() => history.push("/admin/portalusers/all"), 1000);
                    }
                }
            })
            .catch(err => {
                console.log('error', err);
                enqueueSnackbar("Something happened while deleting user.", {variant: "warning"});
            })
    };

    const handleHospiceSelect = (event) => {
        const updateHospice = {...user};
        updateHospice.organization_id = event.value;
        updateHospice.team = null;
        updateHospice.role_id = "";
        updateHospice.region = null;
        if (event.value !== '') {
            setMissingValues({...missingValues, organization_id: false})
        } else {
            setMissingValues({...missingValues, organization_id: true})
        }
        setUser(updateHospice);
    };

    const handleRegionSelect = (event) => {
        const updateHospice = {...user};
        updateHospice.region = regionData[_.findIndex(regionData, {"name": event.value})].region_id;
        if (event.value !== '') {
            setMissingValues({...missingValues, region: false})
        } else {
            setMissingValues({...missingValues, region: true})
        }
        setUser(updateHospice);
    };

    const handleTeamSelect = (event) => {
        const updateHospice = {...user};
        updateHospice.team = teamData[_.findIndex(teamData, {"team_name": event.value})].team_id;
        setUser(updateHospice);
    };
    const handleRoleSelect = (event) => {
        const updateHospice = {...user};
        updateHospice.role_id = event.value;
        setMissingValues({...missingValues, role_id: false});
        setUser(updateHospice);
    };
    const handleTitleSelect = (event) => {
        const updateHospice = {...user};
        updateHospice.title = event.value;
        setUser(updateHospice);
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        const values = {...user};
        if (name === "first_name") {
            values.first_name = value;
            if (value !== '') {
                setMissingValues({...missingValues, first_name: false});
            } else {
                setMissingValues({...missingValues, first_name: true});
            }
        } else if (name === "last_name") {
            values.last_name = value;
            if (value !== '') {
                setMissingValues({...missingValues, last_name: false});
            } else {
                setMissingValues({...missingValues, last_name: true});
            }
        } else if (name === "phone") {
            values.phone = value;
            if (value !== '') {
                setMissingValues({...missingValues, phone: false});
            } else {
                setMissingValues({...missingValues, phone: true});
            }
        } else if (name === "email" && !value.includes(" ")) {
            values.email = value;
            if (value !== '') {
                setMissingValues({...missingValues, email: false});
            } else {
                setMissingValues({...missingValues, email: true});
            }
        } else if (name === "username" && !value.includes(" ")) {
            values.username = value;
        }
        setUser(values);
    };

    const steps = ['General Informations', 'Access rights'];

    function getStepContent(step) {
        switch (step) {
            case 0:
                return <GeneralInformations
                    regionList={regionList}
                    hospicesList={hospicesList}
                    handleHospiceSelect={handleHospiceSelect}
                    handleStatus={handleStatus}
                    handleRequiredInput={handleRequiredInput}
                    handleInput={handleInput}
                    missingValues={missingValues}
                    user={user}
                    handleInputChange={handleInputChange}
                    handleRegionSelect={handleRegionSelect}
                    handleTeamSelect={handleTeamSelect}
                    handleRoleSelect={handleRoleSelect}
                    handleTitleSelect={handleTitleSelect}
                    rolesList={rolesList}
                    possibleEmail={possibleEmail}
                    validEmail={validEmail}
                    setValidEmail={setValidEmail}
                    restrictedDomains={restrictedDomains}
                    setPossibleEmail={setPossibleEmail}
                    setValidUsername={setValidUsername}
                    validUsername={validUsername}
                    isEdit={!!props.edit}
                    hospiceData={hospiceData}
                    teamData={teamData}
                    teamList={teamList}
                    regionData={regionData}
                    checkAvailability={checkAvailability}
                    deleteUser={deleteUser}
                    userType={userType}

                />;
            case 1:
                return <AccessRights
                    roleCategories={roleCategories}
                    rolesList={rolesList}
                    user={user}
                    permissionList={permissionList}
                    setUser={setUser}
                    userType={userType}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    const handleNext = () => {
        if (activeStep === 0) {
            setMissingValues({
                organization_id: user.organization_id === 0,
                first_name: user.first_name.length === 0,
                last_name: user.last_name.length === 0,
                email: user.email.length === 0,
                phone: user.phone.length === 0,
                role_id: user.role_id.length === 0,
            })
        }
        if (firstStep && activeStep === 0) {
            setActiveStep(activeStep + 1);
        }
        if (activeStep === 2) {
            setActiveStep(activeStep + 1);
        }
        if (activeStep === 1) {
            setActiveStep(activeStep + 1);
            if (props.edit) {
                const token = JSON.parse(localStorage.getItem('key'));
                fetch(`${endpoints.hospice_user_edit}${user_id}`, {
                    method: 'put',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token.accessToken
                    },
                    body: JSON.stringify(user)
                })
                    .then(response => {
                        if (response.status === 200) {
                            setWasSuccessful(true);
                            setIsLoading(false);
                        } else {
                            setWasSuccessful(false);
                            setIsLoading(false);
                        }
                    })
                    .catch(err => console.log('error', err));
            } else {
                const token = JSON.parse(localStorage.getItem('key'));
                fetch(endpoints.hospice_user, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token.accessToken
                    },
                    body: JSON.stringify(user)
                })
                    .then(response => {
                        if (response.status === 201) {
                            setWasSuccessful(true);
                            setIsLoading(false);
                        } else {
                            setWasSuccessful(false);
                            setIsLoading(false);
                        }
                    })
                    .catch(err => console.log('error', err));
            }
        }
    };

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const redirectToHospiceUsers = () => {
        history.push("/admin/hospiceusers/all");
    }

    useEffect(() => {
        if (
            user.organization_id &&
            user.first_name.length > 1 &&
            user.last_name.length  > 1 &&
            user.phone.length === 10 &&
            // user.email.length &&
            // user.region &&
            user.role_id &&
            validEmail === emailValidation.success &&
            validUsername === usernameValidation.success
        ) {
            setFirstStep(true);
        } else {
            setFirstStep(false);
        }
        setSecondStep(true);
        setEntered(true);
    }, [user]);

    return (
        <React.Fragment>
            {(isLogged) ? <React.Fragment>
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Typography component="h1" variant="h5" align="center" style={{paddingTop: 10}}>
                            {userType === userTypes.portal ? sectionTitles.editPortalUser : (props.edit ? sectionTitles.editHospiceUser : sectionTitles.addNewHospiceUser)}
                        </Typography>
                        <Stepper activeStep={activeStep} className={classes.stepper}>
                            {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <React.Fragment>
                            {activeStep === steps.length ? (
                                <React.Fragment>
                                    {isLoading ? (
                                        <div style={{display: "flex", justifyContent: 'center'}}>
                                            <CircularProgress/>
                                        </div>
                                    ) : (
                                        <React.Fragment>
                                            <Typography variant="h5" gutterBottom>
                                                {(wasSuccessful && props.edit) && 'Success'}
                                                {(wasSuccessful && !props.edit) && 'Success'}
                                                {!wasSuccessful && props.edit && 'Unable to edit'}
                                                {!wasSuccessful && !props.edit && 'Unable to register'}
                                            </Typography>
                                            <Typography variant="subtitle1">
                                                {(wasSuccessful && props.edit) && 'User has been updated.'}
                                                {wasSuccessful && !props.edit && 'User has been created.'}
                                                {!wasSuccessful && !props.edit && 'Please try again'}
                                            </Typography>
                                            <Button variant="contained" color="primary" onClick={redirectToHospiceUsers}>
                                                View Hospice Users
                                            </Button>
                                            {!props.edit && (
                                                <Grid container style={{paddingTop:24}}>
                                                    <Grid item xs={12}>
                                                        <Button variant={"contained"} color={'primary'}
                                                                onClick={()=>{
                                                                    setUser({
                                                                        status: true,
                                                                        deleted: false,
                                                                        first_name: '',
                                                                        last_name: '',
                                                                        email: '',
                                                                        phone: '',
                                                                        organization_id: user.organization_id,
                                                                        region: user.region,
                                                                        team: user.team,
                                                                        title: '',
                                                                        role_id: '',
                                                                        permissions: '',
                                                                        username: '',
                                                                    });
                                                                    setActiveStep(0);
                                                                }}>
                                                            Create another user for this Organization
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    {getStepContent(activeStep)}
                                    <div className={classes.buttons}>
                                        {entered ? <CancelActionAlert
                                            flag={cancellingAlertFlags.newPatient}
                                            CSS={classes.button}
                                            alertLevel={alertLevel.warn}
                                            target={"/admin"}
                                        /> : <Button
                                            variant={'outlined'}
                                            color="primary"
                                            onClick={() => {
                                                history.push('/admin')
                                            }} className={classes.button}>
                                            Cancel
                                        </Button>
                                        }
                                        {activeStep !== 0 && (
                                            <Button onClick={handleBack} className={classes.button}>
                                                Back
                                            </Button>
                                        )}
                                        {activeStep === 0 && (
                                            <Tooltip
                                                title={firstStep === true || false ? '' : "Please fill all required fields"}
                                                arrow placement="bottom-end">
                                                <Button
                                                    variant={firstStep === true || false ? "contained" : 'outlined'}
                                                    color="primary"
                                                    onClick={handleNext}
                                                    className={classes.button}
                                                >
                                                    {(activeStep === steps.length - 1 && props.edit) && 'Edit User'}
                                                    {(activeStep === steps.length - 1 && !props.edit) && 'Create User'}
                                                    {activeStep !== steps.length - 1 && 'Next'}
                                                </Button>
                                            </Tooltip>
                                        )}
                                        {activeStep === 1 && (
                                            <Tooltip
                                                title={secondStep === true || false ? '' : "Please fill all required fields"}
                                                arrow placement="bottom-end">
                                                <Button
                                                    variant={secondStep === true || false ? "contained" : 'outlined'}
                                                    color="primary"
                                                    onClick={handleNext}
                                                    className={classes.button}
                                                >
                                                    {(activeStep === steps.length - 1 && props.edit) && 'Save Changes'}
                                                    {(activeStep === steps.length - 1 && !props.edit) && 'Create User'}
                                                    {activeStep !== steps.length - 1 && 'Next'}
                                                </Button>
                                            </Tooltip>
                                        )}
                                        {/* {activeStep === 2 && (
                                            <Tooltip
                                                title={secondStep === true || false ? '' : "Please fill all required fields"}
                                                arrow placement="bottom-end">
                                                <Button
                                                    variant={secondStep === true || false ? "contained" : 'outlined'}
                                                    color="primary"
                                                    onClick={handleNext}
                                                    className={classes.button}
                                                >
                                                    {(activeStep === steps.length - 1 && props.edit) && 'Save Changes'}
                                                    {(activeStep === steps.length - 1 && !props.edit) && 'Create User'}
                                                    {activeStep !== steps.length - 1 && 'Next'}
                                                </Button>
                                            </Tooltip>
                                        )} */}
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    </Paper>
                </main>
            </React.Fragment> : ''}
        </React.Fragment>
    );
}
